import { render } from "./ClinicTemplateTab.vue?vue&type=template&id=5a4cfed6&scoped=true"
import script from "./ClinicTemplateTab.vue?vue&type=script&lang=js"
export * from "./ClinicTemplateTab.vue?vue&type=script&lang=js"

import "./ClinicTemplateTab.vue?vue&type=style&index=0&id=5a4cfed6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4cfed6"]])

export default __exports__